/**
 * Stylion official social media URLs.
 * Used for JSON-LD (sameAs), footer, and any shared links.
 */
export const STYLINGCV_SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/stylingcv",
  facebook: "https://www.facebook.com/stylingcv",
  linkedin: "https://www.linkedin.com/company/stylingcv",
  x: "https://x.com/Stylion",
  tiktok: "https://www.tiktok.com/@stylingcv",
  tiktokAlt: "https://www.tiktok.com/@stylingcv1",
  pinterest: "https://www.pinterest.com/stylingcv",
  youtube: "https://www.youtube.com/@stylingcv",
  reddit: "https://www.reddit.com/user/Efficient_Poem_7864",
  dribbble: "https://dribbble.com/stylingcv",
} as const;

/** Ordered array for schema.org sameAs (canonical + alternates). */
export const STYLINGCV_SAME_AS = [
  STYLINGCV_SOCIAL_LINKS.instagram,
  STYLINGCV_SOCIAL_LINKS.facebook,
  STYLINGCV_SOCIAL_LINKS.linkedin,
  STYLINGCV_SOCIAL_LINKS.x,
  STYLINGCV_SOCIAL_LINKS.tiktok,
  STYLINGCV_SOCIAL_LINKS.tiktokAlt,
  STYLINGCV_SOCIAL_LINKS.pinterest,
  STYLINGCV_SOCIAL_LINKS.youtube,
  STYLINGCV_SOCIAL_LINKS.reddit,
  STYLINGCV_SOCIAL_LINKS.dribbble,
];
